import { FocusFile, FocusTag } from '../shared/file-importer/types';
import { ImportSelections } from './use-focus-import-selections';
import { AnnotationCategoryRequest } from '../api/annotations';

export const convertColourToHex = (r: number, g: number, b: number) => {
    const rInRange = Math.max(0, Math.min(r, 255));
    const gInRange = Math.max(0, Math.min(g, 255));
    const bInRange = Math.max(0, Math.min(b, 255));

    const toHex = (section: number) => section.toString(16).padStart(2, '0').toUpperCase();

    return `#${toHex(rInRange)}${toHex(gInRange)}${toHex(bInRange)}`;
};

export const getTagDefaultColour = (tag: FocusTag | undefined): string => {
    return convertColourToHex(tag?.tagColour_r ?? 0, tag?.tagColour_g ?? 0, tag?.tagColour_b ?? 0);
};

export const useFocusAnnotationCategoryMapper = (): ((
    focusFile: FocusFile | undefined,
    selections: ImportSelections,
) => AnnotationCategoryRequest[]) => {
    return (focusFile: FocusFile | undefined, selections: ImportSelections) => {
        if (!focusFile || !focusFile.tags || focusFile.tags.length === 0) {
            return [];
        }

        const tagMap = new Map(focusFile.tags.map((tag) => [tag.tagName, tag]));

        return Array.from(selections.tagAlias.entries()).map(([tagName, importName]) => {
            const tag = tagMap.get(tagName);
            const color = getTagDefaultColour(tag);

            return {
                source_name: tagName,
                import_name: importName,
                start_offset: 0,
                end_offset: 0,
                default_color: color,
                is_bakeable: 1,
                is_event: 0,
            };
        });
    };
};
